import React, { useState, useEffect } from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UIInputFile from "../components/Form/UIInputFile";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';

export default function SitePostForm(props: any){
    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, watch } = methods;
    const [imagePreview, setImagePreview] = useState<string | null>(null);

    const imagemUrl = watch('imagemUrl');

    useEffect(() => {
        if (imagemUrl instanceof FileList && imagemUrl.length > 0) {
            const file = imagemUrl[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        } else if (typeof imagemUrl === 'string' && imagemUrl) {
            const baseUrl = process.env.REACT_APP_API_ENDPOINT;
            setImagePreview(`${baseUrl}/${imagemUrl}`);
        } else {
            setImagePreview(null);
        }
    }, [imagemUrl]);

    return (
        <FormContainer size="lg" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data ? 'Editar Post do Site' : 'Adicionar Post do Site'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <div className="col-7">
                                <div className="row">
                                    <UiInputText size={12} name="titulo" label="Título" required />
                                    <UiInputTextarea size={12} name="descricao" label="Descrição" rows={3} />
                                    <UiInputText size={12} name="linkUrl" label="Link do Post (Instagram)" placeholder="https://www.instagram.com/p/..." />
                                    <UiInputNumberInteger size={6} name="ordem" label="Ordem de Exibição" />
                                    <UiInputCheckbox size={6} name="ativo" label="Ativo" />
                                    <UIInputFile size={12} name="imagemUrl" label="Imagem do Post" />
                                </div>
                            </div>
                            <div className="col-5">
                                <div style={{
                                    border: '2px dashed #dee2e6',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    height: '405px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f8f9fa'
                                }}>
                                    {imagePreview ? (
                                        <img
                                            src={imagePreview}
                                            alt="Preview"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    ) : (
                                        <div style={{
                                            textAlign: 'center',
                                            color: '#6c757d',
                                            fontSize: '14px'
                                        }}>
                                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ marginBottom: '12px' }}>
                                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                                <polyline points="21 15 16 10 5 21"/>
                                            </svg>
                                            <p style={{ margin: 0 }}>Nenhuma imagem selecionada</p>
                                            <p style={{ margin: '4px 0 0 0', fontSize: '12px' }}>O preview aparecerá aqui</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </FormContainer.Body>

                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
